import { Image } from '@grubhubprod/gh-cookbook-react/dist';
import React from 'react';
import { isPhoneView } from 'src/utilities/useScreenSizes';
import { getWindow } from 'src/utilities/window';
import { getConfig } from 'src/utilities/config';
import { isSeamlessRoute } from 'src/utilities/route-utils';

const DESKTOP_WIDTH = '114px';
const MOBILE_WIDTH = '84px';

export default function Logo(): JSX.Element {
  const isTablet = !isPhoneView();
  const window = getWindow();
  const { grubhubLogo, seamlessLogo } = getConfig();
  const isSeamless = isSeamlessRoute();

  const src = isSeamless ? seamlessLogo : grubhubLogo;
  const alt = isSeamless ? 'Seamless logo' : 'Grubhub logo';

  return (
    <div className="cursorPointer">
      <a href={window.location.origin}>
        <Image
          width={isTablet ? DESKTOP_WIDTH : MOBILE_WIDTH}
          src={src}
          alt={alt}
        />
      </a>
    </div>
  );
}
